// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__e-2ew","list":"styles_list__1xCMD"};